import { Label } from "layout/typography/Label";
import { Chips } from "primereact/chips";
import { useState, useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

const Title = styled.h3`
  margin-bottom: 16px;
`;

/**
 * CLE-2935 — no `separator`: payer names such as
 * "BLUECROSS BLUESHIELD KANSAS SOLUTIONS, INC." contain commas, and a comma
 * separator split them into two aliases. Enter is the only way to add one.
 */
export function Aliases() {
  const { control, watch } = useFormContext();
  const [aliases, setAliases] = useState<string[]>([]);
  const watchedAliases = watch("aliases");

  useEffect(() => {
    if (watchedAliases) {
      setAliases(watchedAliases);
    }
  }, [watchedAliases]);

  return (
    <div className="block bg-white border-round p-4 mb-4">
      <Title>Aliases</Title>
      <Label htmlFor="aliases">Add Aliases</Label>
      <Controller
        name="aliases"
        control={control}
        render={({ field: { onChange } }) => (
          <Chips
            id="aliases"
            value={aliases}
            className="w-full mt-2"
            onChange={(e: any) => {
              const trimmed = (e.value ?? [])
                .map((item: any) => String(item).trim())
                .filter((item: string) => item.length > 0);
              setAliases(trimmed);
              onChange(trimmed);
            }}
          />
        )}
      />
    </div>
  );
}
